"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _clsx = _interopRequireDefault(require("clsx"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonAccordion = _interopRequireDefault(require("./common-accordion.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp; // Track the amount of Accordions instantiated to keep ids unique

var accordionInstances = 0;

var hasPanesChanged = function hasPanesChanged(currentChildren, storedChildren) {
  if (currentChildren !== ' ' && storedChildren !== ' ' && currentChildren && storedChildren) {
    if (String(currentChildren[0]) !== String(storedChildren[0]) || currentChildren.length !== storedChildren.length) {
      return true;
    }

    return false;
  }

  return true;
}; // Checks if pane has text content in nested nodes


var paneHasContent = function paneHasContent(node) {
  if (typeof node === 'string' && node.trim() === '') {
    return false;
  }

  if (Array.isArray(node)) {
    return node.some(paneHasContent);
  }

  if (typeof node === 'object' && node !== null) {
    // Check for @common/common-rich-text with HTML
    var html = (0, _get["default"])(node, 'props.html');

    if (html !== undefined) {
      return paneHasContent(html);
    } // Check for components without data, i.e.: @common/cta


    var data = (0, _get["default"])(node, 'props.data');

    if (data !== undefined && (0, _isEmpty["default"])(data)) {
      return false;
    } // Keep checking for empty children


    var children = (0, _get["default"])(node, 'props.children');

    if (children) {
      return paneHasContent(children);
    }
  }

  return true;
}; // Checks if


var checkPanesForChanges = function checkPanesForChanges(currentPanes, storedPanes) {
  var panesChanged = currentPanes.length !== storedPanes.length;

  if (panesChanged === false && currentPanes.length > 0) {
    for (var i = 0; i < currentPanes.length; i += 1) {
      var currentPane = storedPanes[i];
      var storedPane = currentPanes[i];
      var currentHeaderChildren = handleNestedProp(currentPane, 'currentPane.header.child.props.children');
      var currentPanelChildren = handleNestedProp(currentPane, 'currentPane.panel.child.props.children');
      var storedHeaderChildren = handleNestedProp(storedPane, 'storedPane.header.child.props.children');
      var storedPanelChildren = handleNestedProp(storedPane, 'storedPane.panel.child.props.children');
      panesChanged = hasPanesChanged(currentHeaderChildren, storedHeaderChildren);
      panesChanged = hasPanesChanged(currentPanelChildren, storedPanelChildren);
    }
  }

  return panesChanged;
};

var getPaneArray = function getPaneArray(accordionChildren, id, expanded) {
  if (expanded === void 0) {
    expanded = [];
  }

  var panes = [];
  var childNodeTracker = 0;
  var paneInstances = 0; // Populate the child nodes into panes

  accordionChildren.forEach(function (child) {
    if (child.type !== undefined) {
      if (childNodeTracker === 0 || childNodeTracker % 2 === 0) {
        // eslint-disable-line
        // eslint-disable-line
        panes.push({
          header: {
            child: child,
            id: id !== undefined ? "accordion-" + id + "-header-" + paneInstances : "acccordion-" + accordionInstances + "-header-" + paneInstances
          },
          isExpanded: expanded.includes(paneInstances)
        });
      } else {
        panes[panes.length - 1].panel = {
          child: child,
          id: id !== undefined ? "accordion-" + id + "-panel-" + paneInstances : "acccordion-" + accordionInstances + "-panel-" + paneInstances
        };
        paneInstances += 1;
      }

      childNodeTracker += 1;
    } else {
      child.forEach(function (subchild) {
        var subchildren = subchild.props.children;
        getPaneArray(subchildren, id, expanded).forEach(function (childPane) {
          panes.push(childPane);
        });
      });
    }
  });
  return panes;
};

var CommonAccordion = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonAccordion, _React$Component);

  CommonAccordion.resourceType = function resourceType() {
    return 'CommonAccordion_X_Y_Z';
  };

  function CommonAccordion(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var expanded = props.expanded || [];
    _this.state = {
      expandAll: true,
      expanded: expanded
    }; // Update the accordion count tracker

    accordionInstances += 1;
    _this.handleTriggerClick = _this.handleTriggerClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = CommonAccordion.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
      this.setState({
        expandAll: false
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var resetExpanded = false;
    var _this$props = this.props,
        children = _this$props.children,
        id = _this$props.id,
        expanded = _this$props.expanded;

    if (children && prevProps.children) {
      var accordionChildren = children.props.children;
      var prevAccordionChildren = prevProps.children.props.children;
      var prevPanes = getPaneArray(prevAccordionChildren, prevProps.id, []);
      var panes = getPaneArray(accordionChildren, id, []);

      if (checkPanesForChanges(panes, prevPanes)) {
        resetExpanded = true;
      }
    } else {
      resetExpanded = true;
    }

    if (resetExpanded) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        expanded: []
      });
    }

    if (prevProps.expanded.length !== expanded.length) {
      this.setState({
        expanded: expanded
      });
    }
  } // On trigger click
  // Toggle associated panel
  ;

  _proto.handleTriggerClick = function handleTriggerClick(e) {
    this.togglePane(Number(e.currentTarget.getAttribute('data-paneindex')));
    var clickEvent = this.props.clickEvent;
    clickEvent(e.target.innerText);
  } // Toggle pane expansion/collapse based on index
  ;

  _proto.togglePane = function togglePane(paneIndex) {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        multiselectable = _this$props2.multiselectable;
    var expanded = this.state.expanded;
    var expandedIndex = expanded.indexOf(paneIndex);
    var updatedExpanded = expanded.slice();

    if (!disabled.includes(paneIndex)) {
      if (!multiselectable && expandedIndex === -1) {
        updatedExpanded = [paneIndex];
      } else if (!multiselectable && expandedIndex !== -1) {
        updatedExpanded = [];
      } else if (expandedIndex === -1) {
        updatedExpanded.push(paneIndex);
      } else {
        updatedExpanded.splice(expandedIndex, 1);
      }
    }

    this.setState({
      expanded: updatedExpanded
    });
  };

  _proto.renderHeaderButton = function renderHeaderButton(pane, paneIndex, showAsExpanded) {
    var header = pane.header,
        panel = pane.panel;
    var isExpandable = paneHasContent(pane.panel.child);
    var _this$props3 = this.props,
        arrowPath = _this$props3.arrowPath,
        theme = _this$props3.theme,
        disabled = _this$props3.disabled,
        headingsOutside = _this$props3.headingsOutside,
        headerClasses = _this$props3.headerClasses;
    var classesToAdd = headerClasses.join(' ');

    if (headingsOutside === true) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classesToAdd
      }, header.child.props.children), /*#__PURE__*/_react["default"].createElement("button", {
        role: "tab",
        type: "button",
        disabled: disabled.includes(paneIndex) || !isExpandable,
        onClick: this.handleTriggerClick,
        "data-paneindex": paneIndex,
        "aria-controls": panel.id,
        id: header.id,
        className: _commonAccordion["default"].trigger + " " + theme.inputsAndOptions + " " + (arrowPath === undefined ? theme.mmcIconChevronDown : ''),
        "aria-expanded": showAsExpanded,
        "aria-selected": showAsExpanded
      }, arrowPath && /*#__PURE__*/_react["default"].createElement("img", {
        className: _commonAccordion["default"].triggerIndicator + " triggerIndicator",
        "aria-hidden": true,
        alt: "",
        src: arrowPath
      })));
    }

    return /*#__PURE__*/_react["default"].createElement("button", {
      role: "tab",
      type: "button",
      disabled: disabled.includes(paneIndex) || !isExpandable,
      onClick: this.handleTriggerClick,
      "data-paneindex": paneIndex,
      "aria-controls": panel.id,
      id: header.id,
      className: _commonAccordion["default"].trigger + " " + theme.inputsAndOptions + " " + (arrowPath === undefined && isExpandable ? theme.mmcIconChevronDown : '') + " " + classesToAdd,
      "aria-expanded": showAsExpanded,
      "aria-selected": showAsExpanded
    }, header.child.props.children, arrowPath && /*#__PURE__*/_react["default"].createElement("img", {
      className: _commonAccordion["default"].triggerIndicator + " triggerIndicator",
      "aria-hidden": true,
      alt: "",
      src: arrowPath
    }));
  };

  _proto.renderHeaderLineItem = function renderHeaderLineItem(header) {
    var _this$props4 = this.props,
        theme = _this$props4.theme,
        lineItemClasses = _this$props4.lineItemClasses;
    var classesToAdd = lineItemClasses.join(' ');
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonAccordion["default"].trigger + " " + theme.inputsAndOptions + " " + classesToAdd
    }, header.child.props.children));
  } // Take pane data and return pane JSX
  ;

  _proto.renderAccordionPane = function renderAccordionPane(pane, paneIndex) {
    var header = pane.header,
        panel = pane.panel;
    var _this$props5 = this.props,
        expectedPanelHeight = _this$props5.expectedPanelHeight,
        forcedState = _this$props5.forcedState,
        lineItems = _this$props5.lineItems,
        panelClasses = _this$props5.panelClasses;
    var _this$state = this.state,
        expandAll = _this$state.expandAll,
        expanded = _this$state.expanded;
    var panelClassesToAdd = panelClasses.join(' ');
    var AccordionHeader = header.child.type;
    var showAsExpanded = expandAll === true ? true : expanded.includes(paneIndex); // Handle a state being forced on the component

    if (typeof forcedState === 'object' && forcedState !== null) {
      var currentForcedState = forcedState[String(paneIndex)];

      if (currentForcedState === 'expanded') {
        showAsExpanded = true;
      } else if (currentForcedState === 'collapsed') {
        showAsExpanded = false;
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: paneIndex
    }, /*#__PURE__*/_react["default"].createElement(AccordionHeader, {
      className: _commonAccordion["default"].header
    }, lineItems.includes(paneIndex) ? this.renderHeaderLineItem(header) : this.renderHeaderButton(pane, paneIndex, showAsExpanded)), !lineItems.includes(paneIndex) && /*#__PURE__*/_react["default"].createElement("div", {
      role: "tabpanel",
      className: _commonAccordion["default"].panel + " " + _commonAccordion["default"][expectedPanelHeight] + " " + panelClassesToAdd,
      id: panel.id,
      "aria-hidden": !showAsExpanded
    }, panel.child));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props6 = this.props,
        ariaBusy = _this$props6.ariaBusy,
        multiselectable = _this$props6.multiselectable,
        classes = _this$props6.classes,
        borderStyle = _this$props6.borderStyle,
        children = _this$props6.children,
        id = _this$props6.id,
        columns = _this$props6.columns,
        theme = _this$props6.theme;
    var _this$state2 = this.state,
        expanded = _this$state2.expanded,
        expandAll = _this$state2.expandAll;
    var panes = [];

    if (children && children.props && children.props.children) {
      var accordionChildren = children.props.children;
      panes = getPaneArray(accordionChildren, id, expanded);
    }

    var addedClasses = classes.map(function (currentClass) {
      return theme[currentClass];
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.accordion, _commonAccordion["default"].wrapper, _commonAccordion["default"]["borderStyle--" + borderStyle], addedClasses.join(' '), expandAll && _commonAccordion["default"].serverRendered, columns === 2 && theme.row),
      "aria-multiselectable": multiselectable,
      "aria-busy": ariaBusy,
      role: "tablist"
    }, panes.map(function (pane, paneIndex) {
      if (columns === 2) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          // eslint-disable-next-line react/no-array-index-key
          key: paneIndex,
          className: theme['col-xs-12'] + " " + theme['col-sm-6']
        }, _this2.renderAccordionPane(pane, paneIndex));
      }

      return _this2.renderAccordionPane(pane, paneIndex);
    }));
  };

  return CommonAccordion;
}(_react["default"].Component);

exports["default"] = CommonAccordion;
CommonAccordion.displayName = 'CommonAccordion';
CommonAccordion.defaultProps = {
  ariaBusy: true,
  multiselectable: true,
  expectedPanelHeight: 'lg',
  disabled: [],
  expanded: [],
  lineItems: [],
  headerClasses: [],
  headingsOutside: false,
  lineItemClasses: [],
  panelClasses: [],
  classes: [],
  clickEvent: function clickEvent() {}
};